import { useState } from 'react';
import { VictoryPie } from 'victory';
import NoData from '../../../../../../components/NoData';
import OpacityAnimation from '../../../../../../components/OpacityAnimation';
import useThemeContext from '../../../../../../contexts/theme';
import floatToCurrency from '../../../../../../utils/floatToCurrency';
import { Card } from './styles';

interface EconomyCardI {
  initialCost: number;
  finalCost: number;
  economyPercentage: number;
}

export default function EconomyCard({
  initialCost,
  finalCost,
  economyPercentage,
}: EconomyCardI) {
  const { selectedTheme } = useThemeContext();
  const [labelBeingShow, setLabelBeingShow] = useState({ description: '', value: '' });

  return (
    <Card>
      <div className="card-title">
        <div>Nova Despesa ({economyPercentage}% de Economia)</div>
      </div>

      {(!!initialCost && !!finalCost && !!economyPercentage) && (
        <>
          <OpacityAnimation>
            <div className="card-main-graph">
              <VictoryPie
                data={[
                  { x: 'Economizado', y: (initialCost - finalCost) },
                  { x: 'Nova Despesa', y: finalCost }
                ]}
                animate={{
                  duration: 500
                }}
                colorScale="qualitative"
                height={335}
                labelPlacement="vertical"
                labelRadius={0.1}
                labelPosition="endAngle"
                style={{
                  labels: { fontSize: 0, fill: selectedTheme === 'dark' ? '#fff' : '#000' }
                }}
                padding={{ top: 0, bottom: 10 }}
                innerRadius={110}
                padAngle={1}
                events={[{
                  target: 'data',
                  eventHandlers: {
                    onMouseOver: () => {
                      return [
                        {
                          target: 'data',
                          mutation: ({ style, data, index }) => {
                            setLabelBeingShow({ description: data[index].x, value: floatToCurrency(data[index].y) });
                            return { style: Object.assign({}, style, { opacity: '0.8', cursor: 'help' }) };
                          }
                        }
                      ];
                    },
                    onMouseOut: () => {
                      return [
                        {
                          target: 'data',
                          mutation: () => {
                            setLabelBeingShow({ description: '', value: '' });
                            return null;
                          }
                        }
                      ];
                    }
                  }
                }]}
              />
              <label>
                <span>{labelBeingShow.value ? labelBeingShow.value : ''}</span>
                <span>{labelBeingShow.description}</span>
              </label>
            </div>
          </OpacityAnimation>
        </>
      )}

      {(!initialCost) && (
        <NoData
          icon="emptyBox"
          label={(
            <>
              Não há dados de economia para o período selecionado
            </>
          )}
        />
      )}
    </Card>
  );
}
